import { TextField } from '~components/text-field';
import React from 'react';
import { RendererProps } from '../types';

export function IntFieldRenderer({ element }: RendererProps) {
	return <TextField {...element} width={2} />;
}
